import {Case} from './Case';

export class Address {
    buildingnumber: string; // number;
    buildingname: string;
    thoroughfare: string;
    postcode: string;
    titles: Title[];
    cases: Case[];
    uprn: string;
    saon: string; // Address line 1
    paon: string; // Address line 2
    buildingIdentifier: string;
    organisation: string;
    locality: string;
    town: string;
    northing: number;
    easting: number;
    county: string;
    towncity: string;
    caseaddressid: number;
    street: string;
    subbuildingname: string;
    dependentthoroughfarename: string;

    constructor(
        _buildingIdentifier: string,
        _buildingnumber: string,
        _buildingname: string,
        _thoroughfare: string,
        _dependentthoroughfarename: string,
        _postcode: string,
        _titles: Title[],
        _cases: Case[],
        _uprn: string) {
        this.buildingnumber = _buildingnumber;
        this.thoroughfare = _thoroughfare;
        this.dependentthoroughfarename = _dependentthoroughfarename;
        this.postcode = _postcode;
        this.titles = _titles;
        this.cases = _cases;
        this.uprn = _uprn;
        this.buildingname = _buildingname;
        this.buildingIdentifier = _buildingIdentifier;
    }
}

// TODO: Once all the graphs are transitioned, refactor duplicate field names to use a single, consistent naming convention.
export interface Address {
    buildingnumber: string; // number;
    buildingNumber: string; // number;
    buildingname: string;
    buildingName: string;
    thoroughfare: string;

    thoroughfareDescriptor: string;

    dependentthoroughfarename: string;
    dependantThoroughfareName: string;
    saon: string; // Address line 1
    paon: string; // Address line 2
    postcode: string;
    titles: Title[];
    cases: Case[];
    uprn: string;
    county2: string;
    buildingIdentifier: string;
    organisation: string;
    locality: string;
    town: string;
    townCity: string;
    northing: number;
    easting: number;
    county: string;
    subBuildingName: string;
    propertyType: string;
}

export interface Title {
    titlenumber: string;
}


export function sortAddresses(a: Address, b: Address) {
    let first = formatAddress(a);
    let second = formatAddress(b);

    return first.localeCompare(second, 'en-GB', {numeric: true, sensitivity: 'base'});
}

export function formatAddress(addressModel: Address) {
    if (addressModel) {
        let address = '';
        if (addressModel.subbuildingname) {
            address = address + capitalizeFirstLetter(addressModel.subbuildingname) + ', ';
        }
        if (addressModel.buildingname) {
            address = address + capitalizeFirstLetter(addressModel.buildingname) + ', ';
        }
        if (addressModel.buildingnumber) {
            address = address + capitalizeFirstLetter(addressModel.buildingnumber.toString()) + ' ';
        }
        if (addressModel.organisation || addressModel.buildingIdentifier) {
            address = address + capitalizeFirstLetter(addressModel.organisation ?? addressModel.buildingIdentifier) + ', ';
        }
        if (addressModel.organisation) {
            address = address + capitalizeFirstLetter(addressModel.organisation) + ', ';
        }
        if (addressModel.thoroughfare) {
            address = address + capitalizeFirstLetter(addressModel.thoroughfare) + ', ';
        }
        if (addressModel.dependentthoroughfarename) {
            address = address + capitalizeFirstLetter(addressModel.dependentthoroughfarename) + ', ';
        }
        if (addressModel.town) {
            address = address + capitalizeFirstLetter(addressModel.town);

            if (addressModel.county || addressModel.postcode) {
                address = address + ', ';
            }

        }
        if (addressModel.county) {
            address = address + capitalizeFirstLetter(addressModel.county) + ', ';
        }
        if (addressModel.postcode) {
            address = address + addressModel.postcode.toUpperCase();
        }
        return address;
    }
    return;
}

export function toAddress(a: any): Address {
    const address = new Address(
        a.organisation,
        a.buildingNumber,
        a.buildingName,
        a.thoroughfare,
        a.dependentThoroughfareName,
        a.postcode,
        null,
        null,
        a.uprn
    );

    address.town = a.town;
    address.locality = a.locality;
    address.easting = a.easting;
    address.northing = a.northing;
    address.propertyType = a.propertyType;
    address.county = a.county;
    address.subBuildingName = a.subBuildingName;

    return address;
}

export function capitalizeFirstLetter(str: string) {
    if (str) {
        str = str.toLowerCase().replace(/([^a-z])([a-z])(?=[a-z]{2})|^([a-z])/g, function (_, g1, g2, g3) {
            return (typeof g1 === 'undefined') ? g3.toUpperCase() : g1 + g2.toUpperCase();
        });
        return str;
    }
    return '';
}